<template>
	<div>
		<v-progress-circular
			indeterminate
			color="primary"
			:size="30"
			width="2"
			v-if="loading"
			class="ma-1"
		></v-progress-circular>
		<div>
			<editor
				:api-key="apiKey"
				v-model="newValue"
				:init="getEditorConfig(true)"
				@onInit="onInit"
			></editor>
			<v-btn
				v-on:click="save"
				class="mt-3"
				small
				v-if="!loading && onSave"
			>
				Išsaugoti
			</v-btn>
		</div>
		<v-dialog
			v-model="dialog"
			max-width="1000px"
		>
			<v-card>
				<v-card-title>
					<span>Teksto redagavimas...</span>
				</v-card-title>
				<v-card-text>
					<template v-if="dialogReady">
						<editor
							:api-key="apiKey"
							v-model="newValue"
							:init="getEditorConfig()"
							@onInit="onInitModal"
						></editor>
					</template>
					<template v-else>
						<v-progress-circular
							indeterminate
							color="primary"
							:size="30"
							width="2"
							v-if="loading"
							class="ma-1"
						></v-progress-circular>
					</template>
				</v-card-text>
				<v-card-actions>
					<v-btn
						text
						@click="dialog = false"
					>
						Uždaryti
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
	import Editor from "@tinymce/tinymce-vue"; // asdfgh45Q

	export default {
		data: function(){
			var data = {
				apiKey: "ajdep40wgsvfwzqlj3ikmmisp98utp3xiz1rsu5rnzq6szjk", // lotrmj@gmail.com
				loading: true,
				newValue: "",
				dialog: false,
				dialogReady: false
			};
			return data;
		},
		props: {
			content: Object,
			onSave: Function
		},
		components: {
			editor: Editor
		},
		methods: {
			onInit: function(){
				this.loading = false;
			},
			onInitModal(e, editor) {
				this.modalEditor = editor;
			},
			getEditorConfig(fsButton) {
				var config = {
					height: 400,
					menubar: true,
					plugins: [
						"link image table media" // Anksčiau buvo "pageembed", bet 06.01 dabar tai mokama?.. Ar jis mums reikalingas?..
					],
					toolbar1: "undo redo my-fs | bold italic alignleft aligncenter alignright alignjustify",
					toolbar2: "link image",
					language: "lt",
					language_url: "/atlas/tinymce/lt.js", // FIXME! Tas kelias turi būti kažkokiame kintamajame?
					setup: function(editor){
						// https://www.tiny.cloud/docs/ui-components/typesoftoolbarbuttons/
						if (fsButton) {
							editor.ui.registry.addButton("my-fs", {
								icon: "fullscreen",
								tooltip: "Pateikti teksto redagavimo komponentą pilname ekrane",
								onAction: function(){
									if (this.modalEditor) {
										this.modalEditor.undoManager.reset();
									}
									this.dialog = true;
									setTimeout(function(){ // Be timeout'o blogai susiformuoja editor'ius!!! Gal dėl to, kad duotuoju metu nežinomas konteinerio dydis ar kažkas tokio...
										if (this.dialog) {
											this.dialogReady = true;
										}
									}.bind(this), 0);
								}.bind(this)
							});
						}
					}.bind(this)
				};
				return config;
			},
			save: function(){
				this.$set(this.content, "value", this.newValue);
				if (this.onSave) {
					this.onSave();
				}
			}
		},
		watch: {
			content: {
				immediate: true,
				handler: function(content){
					this.newValue = content.value || ""; // Lyg ir svarbu perduoti bent jau tuščią string'ą...
				}
			}
		}
	}
</script>

<style scoped>
	.v-progress-circular {
		position: absolute;
	}
</style>